__turbopack_context__.v({
  "buttonContainer": "ControlView-module__FOg0hq__buttonContainer",
  "buttonContainerLandscape": "ControlView-module__FOg0hq__buttonContainerLandscape",
  "controlView": "ControlView-module__FOg0hq__controlView",
  "panelContainer": "ControlView-module__FOg0hq__panelContainer",
  "panelContainerLandscape": "ControlView-module__FOg0hq__panelContainerLandscape",
  "unsubscribeWrapper": "ControlView-module__FOg0hq__unsubscribeWrapper",
  "unsubscribeWrapperLandscape": "ControlView-module__FOg0hq__unsubscribeWrapperLandscape",
});
